import { render, staticRenderFns } from "./im_teacher.vue?vue&type=template&id=0a2e3312&scoped=true&"
import script from "./im_teacher.vue?vue&type=script&lang=js&"
export * from "./im_teacher.vue?vue&type=script&lang=js&"
import style0 from "./im_teacher.vue?vue&type=style&index=0&id=0a2e3312&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2e3312",
  null
  
)

export default component.exports